import { Component, ElementRef, OnInit, WritableSignal, ViewChild, AfterViewInit } from "@angular/core";
import { Location } from "@angular/common";
import { Table } from 'primeng/table';
import { BreadcrumbService } from '../../app.breadcrumb.service';

import { RequisitionMin } from '../../entites/requisition-min';
import { MenuItem, TreeNode } from 'primeng/api';
import { MessageService, LazyLoadEvent, ConfirmationService } from 'primeng/api';

import { DialogService } from 'primeng/dynamicdialog';
import { ItemMin } from '../../entites/item-min';
import { ItemService } from '../../services/item-service';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../base/base-component';
import { Item } from '../../entites/item';
import { FournisseurService } from 'src/app/services/fournisseur-service';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { Emplacement } from 'src/app/entites/emplacement';
import { EmplacementService } from 'src/app/services/emplacement-service';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ContextMenu } from 'primeng/contextmenu/public_api';
import { RapportService } from 'src/app/services/rapport-service';
import { SelectionEmployeComponent } from 'src/app/controles/selection-employe.component';
import { EmployeEntite } from 'src/app/entites/employe';
import { RechercheAdresseComponent } from 'src/app/controles/recherche-adresse.component';
import { AdresseEntite } from 'src/app/entites/adresse';
import { AttributEntite } from 'src/app/entites/attribut';
import { CodeProjetEntite } from 'src/app/entites/code-projet';
import { Subscription } from "rxjs";
import { AchatService } from 'src/app/services/achat-service';
import { ClientEntite } from 'src/app/entites/client';
import { Marker } from 'mapbox-gl';
import { Map } from 'mapbox-gl';
import { environment } from 'src/environments/environment';
import { ETypeLien } from 'src/app/entites/enums/type-lien-document';
import { ContexteService } from "src/app/services/contexte-service";
import { FilterConfig, FiltresAvances } from "../items/controles/filtres-avances.component";
import { Statut } from "src/app/entites/statut";
import { SousCategorieEntite } from "src/app/entites/sousCategorie";
import { CategorieEntite } from "src/app/entites/categorie";
import { MembreEmplacement } from "src/app/entites/membre-emplacement";
import { TabViewChangeEvent } from "primeng/tabview";
import { ModifierAttributsMembreEmplacementComponent } from "./controles/modifier-attributs-membre-emplacement/modifier-attributs-membre-emplacement.component";
import { TieredMenu } from "primeng/tieredmenu";
import { EmplacementAdresseEntite } from "src/app/entites/emplacement-adresse-entite";
import { AjouterAdresseEmplacementComponent } from "./controles/ajouter-adresse-emplacement/ajouter-adresse-emplacement.component";
import { ThemeService } from "src/app/services/theme.service";
import { ItemCommandeEntite } from "src/app/entites/item-commande";
import { ETypeSelectionItem, ResultatSelectionItem, SelectionItemComponent } from "src/app/controles/selection-item.component";
import { CommandeService } from "src/app/services/commande-service";
import { EvaluationFournisseurEmplacementComponent } from "./controles/evaluation-fournisseur-emplacement/evaluation-fournisseur-emplacement.component";
@Component({
    templateUrl: './detail-emplacement.component.html',
    styleUrls: ['./detail-emplacement.component.scss'],
    providers: [MessageService, DialogService]
})
export class DetailEmplacementComponent extends BaseComponent implements OnInit, AfterViewInit {

    emplacementId: number;
    emplacement: Emplacement;

    codesProjet: CodeProjetEntite[];

    detailItemId: number;
    afficherDetailItem: boolean = false;

    menu: MenuItem[];
    tabIndex: WritableSignal<number> = this.createParamSignal('tab', 0);

    attributs: AttributEntite[];

    statuts: Statut[];
    categories: CategorieEntite[];
    sousCategories: SousCategorieEntite[];

    commandes: ItemCommandeEntite[];

    menuContextuelItem: MenuItem[] = [];

    chargementCompleteInventaire: boolean = false;
    inventaire: ItemMin[];
    prefetchedPrevPage: ItemMin[] = null;
    prefetchedNextPage: ItemMin[] = null;
    currentFirst: number = 0;
    lastInventaireRequest: Subscription = null;
    totalInventaire: number = 0;
    itemInventaire: ItemMin;
    filtreCodeProjet: boolean = false;

    membres: MembreEmplacement[];
    travailleurs: MembreEmplacement[];

    // Address management
    adressesEmplacement: EmplacementAdresseEntite[] = [];
    chargementAdresses: boolean = false;

    chargementCompleteHistorique: boolean = false;
    selectionHistorique: RequisitionMin;
    menuContexteHistorique: MenuItem[];

    dialogueAjustementInventaire = false;

    afficherFiltresAvances: boolean = false;

    filterConfigs: FilterConfig[] = [
        {
            key: 'filtreProduitDangereux',
            label: 'Produit dangereux',
            type: 'selectButton',
            field: 'produitDangereux',
            defaultValue: null,
            options: [
                { label: 'Tous', value: null },
                { label: 'Oui', value: true },
                { label: 'Non', value: false }
            ]
        },
        {
            key: 'filtreCodeProjet',
            label: 'Inventaire projet complet',
            type: 'checkbox',
            field: 'codeProjet',
            defaultValue: false,
            isCustomFilter: true,
            customFilterFunction: (value: boolean, allFilters: FiltresAvances) => {
                this.filtreCodeProjet = value;
            }
        }
    ];

    filtres: FiltresAvances = {
        filtreProduitDangereux: null
    };

    actions: MenuItem[] = [];

    @ViewChild('dtInventaire') tableInventaire: Table;
    @ViewChild('menuContextuelItemComponent') menuContextuelItemComponent: TieredMenu;

    client: ClientEntite;

    @ViewChild('map') mapElement: ElementRef;
    map: Map;


    mapCenter: [number, number] = [-71.2080, 46.8139]; // Default center (Quebec City)

    afficherAdresseContact: boolean = false;
    afficherInformationsContact: boolean = false;

    marker: Marker = null;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        public appMain: AppMainComponent, location: Location,
        private breadcrumbService: BreadcrumbService,
        private ItemsService: ItemService,
        private emplacementService: EmplacementService,
        public rapportService: RapportService,
        private messageService: MessageService,
        private fournisseurService: FournisseurService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        private achatService: AchatService,
        public routerService: Router,
        public themeService: ThemeService,
        private contexteService: ContexteService,
        private commandeService: CommandeService) {


        super(sdb, profilService, route, routerService, appMain);

        this.breadcrumbService.setItems([
            { label: 'Emplacements', routerLink: '/emplacements' },
            { label: 'Détails' }
        ]);

        this.route.params.subscribe(params => this.emplacementId = params.id);
    }

    ngOnInit() {

        this.verifierAccesPage('emplacement_detail');

        if (this.contexteService.ValiderPresence(["tab"])) {
            this.tabIndex.set(Number(this.contexteService.Obtenir("tab")));
            this.contexteService.Supprimer("tab");
        }

        this.attributs = this.sdb.Attributs();
        this.statuts = this.sdb.Statuts();
        this.codesProjet = this.sdb.CodesProjet();
        this.categories = this.sdb.Categories();
        this.sousCategories = this.sdb.SousCategories();

        this.colonnesDisponibles = [
            { base: true, champ: 'categorie', entete: 'Catégorie', afficheParDefaut: true },
            { base: true, champ: 'sousCategorie', entete: 'Sous-catégorie', afficheParDefaut: true },
            { base: true, champ: 'marque', entete: 'Marque', afficheParDefaut: true },
            { base: true, champ: 'modele', entete: 'Modèle', afficheParDefaut: true },
            { base: true, champ: 'noCtrl', entete: 'No Ctrl', afficheParDefaut: false },
            { base: true, champ: 'compagnie', entete: 'Compagnie', afficheParDefaut: false },
            { base: true, champ: 'dateArriveEnChantier', entete: 'Date d\'arrivée en chantier', afficheParDefaut: false }
        ];
        this.attributs.forEach(att => {
            this.colonnesDisponibles.push({
                base: false,
                champ: 'att' + att.attributId,
                entete: att.nom,
                afficheParDefaut: false
            })
        });
        this.colonnesSelectionnees = this.colonnesDisponibles.filter(x => x.afficheParDefaut);

        this.emplacementService.ObtenirDetail(this.emplacementId).then(res => {
            this.emplacement = res.valeur;

            if (!this.emplacement.adresse) {
                this.emplacement.adresse = {};
            }

            if (this.emplacement.codeProjet) {
                this.emplacement.codeProjet = this.codesProjet.find(x => x.codeProjetId == this.emplacement.codeProjet.codeProjetId);
                this.chargerInformationClient();
            }

            this.CompleterChargement();
            this.surChangementOnglet({ index: this.tabIndex(), originalEvent: null });
            this.initialiserMenu();
            this.initMap();

            // Load additional addresses if we're on the general info tab
            if (this.tabIndex() === 0) {
                this.chargerAdressesEmplacement();
            }
        });


        this.menuContexteHistorique = [
            {
                label: 'Voir la réquisition',
                icon: 'pi pi-fw pi-check-square',
                command: () => this.routerService.navigateByUrl('transport/' + this.selectionHistorique.requisitionId)
            }
        ];
        // // Initialize map with default center
        // this.mapOptions = {
        //     center: { lat: 46.8139, lng: -71.2080 }, // Quebec City center
        //     zoom:  13,
        //     mapTypeControl: false,
        //     streetViewControl: false,
        //     fullscreenControl: false
        // };

    }

    ngAfterViewInit() {
        this.chargerColonnesSelectionnees();
    }

    initMap() {
        setTimeout(() => {
            this.map = new Map({
                container: this.mapElement.nativeElement,
                style: 'mapbox://styles/adminhc/cm6p7rhpi001v01qogqiq9wbj',
                zoom: 13,
                center: this.mapCenter,
                pitch: 35,
                bearing: 0,
                accessToken: environment.mapbox.accessToken
            });
            setTimeout(() => {
                this.updateMapMarker();
            }, 500);
        }, 500);
    }

    initialiserMenu() {
        this.menu = [
            {
                label: 'Retour', icon: 'pi pi-fw pi-angle-double-left', command: () => window.history.back()
            },
            {
                label: 'Actions',
                icon: 'pi pi-fw pi-bars',
                visible: this.estAutorise('emplacement_action_archiver'),
                items: [
                    {
                        label: 'Archiver',
                        icon: 'pi pi-fw pi-times',
                        visible: this.estAutorise('emplacement_action_archiver'),
                        disabled: this.emplacement.statut.statutId == EStatuts.Archive,
                        command: () => this.archiver()
                    }
                ]
            },
        ];

        this.actions = [
            {
                label: 'Passer une commande',
                icon: 'pi pi-fw pi-plus',
                visible: this.estAutorise('precommande_detail'),
                command: () => this.passerCommande()
            },
            {
                label: 'Voir les garanties',
                icon: 'pi pi-fw pi-shield',
                visible: this.estAutorise('garanties'),
                command: () => this.routerService.navigateByUrl('garanties?assignation=' + this.emplacement.nom)
            },
            {
                label: 'Voir les locations',
                icon: 'pi pi-fw pi-tag',
                visible: this.estAutorise('locations'),
                command: () => this.routerService.navigate(['locations'], { queryParams: { filters: '{"emplacement.emplacementId":[{"value":[' + this.emplacement.emplacementId + '],"matchMode":"in","operator":"and"}]}' } })
            },
            {
                label: 'Voir les bons de commande',
                icon: 'pi pi-shopping-cart',
                visible: this.estAutorise('bdcs') && this.emplacement.codeProjet != null,
                command: () => this.routerService.navigateByUrl('achats?filters={"projet.nom":[{"value":"' + this.emplacement.codeProjet.nom + '","matchMode":"startsWith","operator":"and"}]}')
            },
            {
                label: 'Voir les évaluations fournisseur',
                icon: 'pi pi-fw pi-star',
                command: () => this.ouvrirEvaluationFournisseur()
            },
            {
                label: 'Autres à venir...',
                disabled: true,
            }
        ];
    }

    ouvrirEvaluationFournisseur() {
        this.dialogService.open(EvaluationFournisseurEmplacementComponent, {
            header: 'Évaluations fournisseur',
            width: '95%',
            data: { emplacementId: this.emplacement.emplacementId, emplacement: this.emplacement }
        });
    }


    passerCommande() {
        const ref = this.dialogService.open(SelectionItemComponent, {
            data: {
                type: ETypeSelectionItem.PreCommande,
                employeId: this.profilService.ProfilCourant().employeId,
                selectionCodeProjet: this.emplacement.codeProjet?.codeProjetId
            },
            header: 'Sélection d\'un item',
            width: '95%',
        }).onClose.subscribe((res: ResultatSelectionItem) => {
            if (res) {
                var itemCommande: ItemCommandeEntite = {
                    itemCommandeId: 0,
                    emplacement: { emplacementId: this.emplacement.emplacementId },
                    item: res.item,
                    statut: this.sdb.Statut(EStatuts.EnCours),
                    employe: this.profilService.ProfilCourant(),
                    dateDemande: new Date(),
                    quantiteDemande: res.quantiteDemande,
                    quantite: res.quantiteDemande,
                    expediteur: res.expediteur,
                    demandeur: res.demandeur,
                    dateRequis: res.dateRequis,
                    codeProjet: res.codeProjet,
                    codeActivite: res.codeActivite,
                    codeCategorie: res.codeCategorie,
                    codeExtra: res.codeExtra,
                    codeEquipement: res.codeEquipement,
                    note: res.note,
                    indPrecommande: true
                }

                this.DemarrerChargement();
                this.commandeService.CreerItemCommande({
                    itemCommande: itemCommande
                }).then(res => {
                    if (res.estUnSucces) {
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Commande créée.' });
                        this.tabIndex.set(4);
                        this.CompleterChargement();
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });
            }
        });
    }

    obtenirValeurAttribut(item: Item, attributId: string): string {

        var attId = Number(attributId.replace('att', ''));
        var att = item.valeursAttributs.find(x => x.attribut.attributId == attId);
        if (att) {
            return att.valeur;
        } else {
            return '';
        }

    }

    surChangementOnglet(event: TabViewChangeEvent) {
        if (event.index == 0 && this.adressesEmplacement.length === 0) {
            // Load additional addresses when accessing general info tab
            this.chargerAdressesEmplacement();
            this.emplacementService.ObtenirDernieresCommandesEmplacement(this.emplacementId).subscribe({
                next: x => this.commandes = x,
            });
        }
        if (event.index == 2 && !this.membres) {
            this.emplacementService.ObtenirMembres(this.emplacementId).subscribe({
                next: (res: MembreEmplacement[]) => {
                    this.membres = res.filter(x => !x.indAjoutAuto);
                    this.travailleurs = res.filter(x => x.indAjoutAuto);
                },
                error: (error) => this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue lors de la récupération des membres: ${error.error}` })
            });
        }
    }

    btnModifier_click() {
        this.Modifier();
    }

    annulerModification() {
        this.DemarrerChargement();

        this.emplacementService.ObtenirDetail(this.emplacementId).then(res => {

            this.emplacement = res.valeur;
            this.CompleterChargement();
            this.Consulter();
            this.initMap();
        });


    }

    submitted = false;

    enregistrerModifications() {
        this.submitted = true;
        this.messageService.clear();

        if (this.validerModificationItem()) {
            this.DemarrerChargement();
            this.emplacementService.ModifierEmplacement(this.emplacement).then(x => {
                if (x.estUnSucces) {
                    this.Consulter();
                    this.initMap();
                    this.sdb.ReinitialiserEmplacements();
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Emplacement modifié.' });
                    this.chargerInformationClient();
                } else {
                    x.messages.forEach(x => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description, sticky: true });
                    });
                }
                this.CompleterChargement();
            });
        }
    }

    validerModificationItem(): boolean {

        if (!this.emplacement.code || !this.emplacement.nom) {
            return false;
        }

        return true;
    }

    rechercherAdresse() {
        const ref = this.dialogService.open(RechercheAdresseComponent, {
            header: 'Recherche une adresse',
            width: '50%'
        }).onClose.subscribe((r: AdresseEntite) => {
            if (r) {
                this.emplacement.adresse = r;
                this.updateMapMarker();
            }
        });
    }

    copierDescription() {
        this.emplacement.adresse.nom = this.emplacement.nom;

        this.messageService.add({ severity: 'info', summary: 'Description copiée', detail: this.emplacement.adresse.nom });
    }

    surAjoutEmplacement() {
        // TODO
    }

    OuvrirDetailItem(itemId: number) {
        this.routerService.navigateByUrl(`item/${itemId}`)
        this.messageService.add({ severity: 'info', summary: 'Item Selected', detail: itemId.toString() });
    }

    OuvrirDetailItemNouvelOnglet(itemId: number) {
        this.appMain.detailItemId = itemId;
        this.appMain.afficherDetailItem = true;
    }

    archiver() {
        this.routerService.navigateByUrl(`emplacement/archiver/${this.emplacement.emplacementId}`)
        /* this.confirmationService.confirm({
           message: `Voulez-vous vraiment archiver l'emplacement ${this.emplacement.nom} ?`,
           accept: () => {
               //TODO
               this.emplacement.statut = this.sdb.Statut(EStatuts.Archive);
               this.initialiserMenu();
               this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Emplacement archivé' });
           }
       }); */
    }



    ajustementInventaire() {
        /* this.confirmationService.confirm({
            message: `Voulez-vous vraiment envoyer l'item ${} en?`,
            accept: () => {
                this.messageService.add({ severity: 'success', summary: 'Bon de commande transféré', detail: 'Nouveau numéro du bon de commande: 15240' });
                this.bdc.numero = '15240';
                this.bdc.statut = 'Complété';
                this.menu[2].disabled = false;
                this.menu[3].items[0].disabled = true;
            }
        }); */
        this.dialogueAjustementInventaire = true;
    }

    ajusterInventaire() {
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Inventaire ajusté.' });
        this.dialogueAjustementInventaire = false;
    }



    /* TAB: INVENTAIRE */

    exportExcel() {

        var t = this.tableInventaire.value;

        if (this.tableInventaire.filteredValue) {
            t = this.tableInventaire.filteredValue;
        }




        var lignes: any[] = t.map(x => ({
            Numéro: x.numero,
            Description: x.description,
            Statut: x.statut.nom
        }));

        for (let index = 0; index < lignes.length; index++) {
            if (this.colonnesSelectionnees.filter(x => x.champ == 'categorie').length == 1) {
                if (t[index].categorie && t[index].categorie.nom) {
                    lignes[index].Categorie = t[index].categorie?.nom;
                } else {
                    lignes[index].Categorie = '';
                }
                lignes[index].Categorie = t[index].categorie?.nom;
            }
            if (this.colonnesSelectionnees.filter(x => x.champ == 'sousCategorie').length == 1) {
                if (t[index].sousCategorie && t[index].sousCategorie.nom) {
                    lignes[index].SousCategorie = t[index].sousCategorie?.nom;
                } else {
                    lignes[index].SousCategorie = '';
                }
            }
            if (this.colonnesSelectionnees.filter(x => x.champ == 'marque').length == 1) {
                if (t[index].marque) {
                    lignes[index].Marque = t[index].marque;
                } else {
                    lignes[index].Marque = '';
                }
            }
            if (this.colonnesSelectionnees.filter(x => x.champ == 'modele').length == 1) {
                if (t[index].modele) {
                    lignes[index].Modele = t[index].modele;
                } else {
                    lignes[index].Modele = '';
                }
            }
            if (t[index].quantite) {
                lignes[index].Quantite = t[index].quantite;
            } else {
                lignes[index].Quantite = '';
            }
            if (this.colonnesSelectionnees.filter(x => x.champ == 'noCtrl').length == 1) {
                if (t[index].noCtrl) {
                    lignes[index].NoCtrl = t[index].noCtrl;
                } else {
                    lignes[index].NoCtrl = '';
                }
            }
            if (this.colonnesSelectionnees.filter(x => x.champ == 'emplacement').length == 1) {
                if (t[index].emplacement && t[index].emplacement.nom) {
                    lignes[index].Emplacement = t[index].emplacement?.nom;
                } else {
                    lignes[index].Emplacement = '';
                }
            }
            if (this.colonnesSelectionnees.filter(x => x.champ == 'compagnie').length == 1) {
                if (t[index].compagnie && t[index].compagnie.nom) {
                    lignes[index].Compagnie = t[index].compagnie?.nom;
                } else {
                    lignes[index].Compagnie = '';
                }
            }

            this.attributs.forEach(att => {

                if (this.colonnesSelectionnees.filter(x => x.champ == 'att' + att.attributId).length == 1) {

                    var a = t[index].valeursAttributs.find(x => x.attribut.attributId == att.attributId);

                    if (a) {
                        lignes[index][att.nom] = a.valeur;
                    } else {
                        lignes[index][att.nom] = '';
                    }
                }
            });

        }

        this.messageService.add({ severity: 'info', summary: 'Demande de rapport', detail: `Votre demande de rapport a été envoyée.` });

        this.rapportService.ProduireRapportExcel({
            contenu: JSON.stringify(lignes)
        }).then(x => {
            if (x) {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Votre rapport a été généré.` });
            } else {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue pendant la génération de votre rapport.` });
            }
        });

    }

    /* TAB: MEMBRES */

    ajouterMembre() {
        const ref = this.dialogService.open(SelectionEmployeComponent, {
            header: 'Ajout d\'un membre',
            width: '60%'
        }).onClose.subscribe((resSelectionEmploye: EmployeEntite) => {
            if (resSelectionEmploye) {
                var membre = { employeId: resSelectionEmploye.employeId, employe: resSelectionEmploye, indChargeProjet: false, indResponsable: false, indReceptionRapportJournalier: false, indReceptionPriseHeures: false, indReceptionEntreesSorties: false, indSst: false };
                const ref = this.dialogService.open(ModifierAttributsMembreEmplacementComponent, {
                    header: 'Modifier les attributs du membre',
                    width: '60%',
                    data: { membre: membre }
                }).onClose.subscribe((resMembre: MembreEmplacement) => {
                    if (resMembre) {
                        membre = resMembre;
                        this.emplacementService.AjouterMembre(this.emplacementId, membre.employe.employeId, {
                            IndChargeProjet: membre.indChargeProjet,
                            IndResponsable: membre.indResponsable,
                            IndReceptionRapportJournalier: membre.indReceptionRapportJournalier,
                            IndReceptionPriseHeures: membre.indReceptionPriseHeures,
                            IndReceptionEntreesSorties: membre.indReceptionEntreesSorties,
                            IndSst: membre.indSst
                        }).subscribe({
                            next: res => {
                                this.Debloquer();
                                this.emplacementService.ObtenirMembres(this.emplacementId).subscribe({
                                    next: x => this.membres = x,
                                    error: (error) => this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue lors de la récupération des membres: ${error.error}` })
                                });
                                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Membre ajouté.' });
                            },
                            error: (error) => this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue lors de l'ajout du membre: ${error.error}` })
                        });
                    }
                });
            }
        });
    }

    modifierAttributsMembre(membre: MembreEmplacement) {
        const ref = this.dialogService.open(ModifierAttributsMembreEmplacementComponent, {
            header: 'Modifier les attributs du membre',
            width: '60%',
            data: { membre: membre }
        }).onClose.subscribe((resMembre: MembreEmplacement) => {
            if (resMembre) {
                membre = resMembre;
                this.emplacementService.ModifierMembre(this.emplacementId, membre.employe.employeId, {
                    IndChargeProjet: membre.indChargeProjet,
                    IndResponsable: membre.indResponsable,
                    IndReceptionRapportJournalier: membre.indReceptionRapportJournalier,
                    IndReceptionPriseHeures: membre.indReceptionPriseHeures,
                    IndReceptionEntreesSorties: membre.indReceptionEntreesSorties,
                    IndSst: membre.indSst
                }).subscribe({
                    next: res => {
                        this.membres = this.membres.map(val => val.employe.employeId === membre.employe.employeId ? membre : val);
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Membre modifié' });
                    },
                    error: (error) => this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue lors de la modification du membre: ${error.error}` })
                });
            }
        });
    }

    supprimerMembre(employe: EmployeEntite) {
        this.confirmationService.confirm({
            message: 'Voulez-vous vraiment supprimer le membre sélectionné ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.emplacementService.SupprimerMembre(this.emplacementId, employe.employeId).subscribe({
                    next: res => {
                        this.membres = this.membres.filter(val => val.employe.employeId !== employe.employeId);
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Membre supprimé' });
                    },
                    error: (error) => this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue lors de la suppression du membre: ${error.error}` })
                });
            }
        });
    }

    /// <summary>
    /// Handles context menu display for items, ensuring proper positioning when hovering over different elements
    /// </summary>
    /// <param name="event">The mouse event containing position information</param>
    /// <param name="item">The item for which to show the context menu</param>
    surMenuContextuelItem(event: MouseEvent, item: Item) {
        this.menuContextuelItem = this.ItemsService.getItemActions(item);

        if (this.menuContextuelItemComponent.visible) {
            this.menuContextuelItemComponent.hide();
            // Preserve event properties before setTimeout as MouseEvent object may become invalid
            const eventClone = {
                clientX: event.clientX,
                clientY: event.clientY,
                pageX: event.pageX,
                pageY: event.pageY,
                target: event.target,
                currentTarget: event.currentTarget
            } as any;

            // Add a small delay to ensure the menu is properly hidden before repositioning
            setTimeout(() => {
                this.menuContextuelItemComponent.show(eventClone);
                setTimeout(() => {
                    (this.menuContextuelItemComponent as any).dirty = true;
                }, 50);
            }, 50);
        } else {
            this.menuContextuelItemComponent.show(event);
            setTimeout(() => {
                (this.menuContextuelItemComponent as any).dirty = true;
            }, 100);
        }
    }

    onLazyLoadInventaire(event: LazyLoadEvent) {

        this.chargementCompleteInventaire = false;

        // Cancel previous request if still running
        if (this.lastInventaireRequest) {
            this.lastInventaireRequest.unsubscribe();
        }

        // Load current page
        this.lastInventaireRequest = this.emplacementService.ObtenirInventaire(this.emplacementId, this.filtreCodeProjet, event).subscribe({
            next: x => {
                this.inventaire = x.valeur.elements ?? [];
                this.totalInventaire = x.valeur.maxCount ?? 0;
                this.chargementCompleteInventaire = true;
                this.prefetch(event);
            },
            error: () => {
                this.inventaire = [];
                this.totalInventaire = 0;
                this.chargementCompleteInventaire = true;
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue lors de la récupération de l\'inventaire.' });
            }
        });
    }

    prefetch(event: LazyLoadEvent) {
        // Async prefetch previous page
        if (event.first > 0) {
            const prevEvent = { ...event, first: event.first - event.rows };
            this.emplacementService.ObtenirInventaire(this.emplacementId, this.filtreCodeProjet, prevEvent).subscribe();
        }

        // Async prefetch next page
        if (event.first + event.rows < this.tableInventaire.totalRecords) {
            const nextEvent = { ...event, first: event.first + event.rows };
            this.emplacementService.ObtenirInventaire(this.emplacementId, this.filtreCodeProjet, nextEvent).subscribe();
        }
    }

    private chargerInformationClient() {
        if (this.emplacement.codeProjet?.client?.clientId) {
            this.DemarrerChargement();
            this.achatService.ObtenirDetailClient(this.emplacement.codeProjet.client.clientId).subscribe({
                next: res => {
                    if (res.body) {
                        this.client = res.body;
                    } else {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue lors de la récupération du client.' });
                    }
                    this.CompleterChargement();
                },
                error: () => {
                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue lors de la récupération du client.' });
                    this.CompleterChargement();
                }
            });
        } else {
            this.client = null;
        }
    }

    updateMapMarker() {
        if (!this.emplacement.adresse?.municipalite) {
            return;
        }

        const address = `${this.emplacement.adresse.numero} ${this.emplacement.adresse.rue}, ${this.emplacement.adresse.municipalite}, ${this.emplacement.adresse.province}, ${this.emplacement.adresse.codePostal}`;

        // Use Mapbox Geocoding API to get coordinates
        fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json?access_token=${environment.mapbox.accessToken}`)
            .then(response => response.json())
            .then(data => {
                if (data.features && data.features.length > 0) {
                    const coordinates = data.features[0].center;
                    this.map.setCenter(coordinates);


                    if (this.marker) {
                        this.marker.remove();
                    }

                    this.marker = new Marker({
                        color: '#00843D',
                    })
                        .setLngLat(coordinates);

                    this.marker.addTo(this.map);
                }
            });
    }

    reinitialiserFiltres() {
        this.filtres = {
            filtreProduitDangereux: null
        };
    }

    get ETypeLienDocument() {
        return ETypeLien;
    }

    /// <summary>
    /// Loads all additional addresses for the current emplacement
    /// </summary>
    chargerAdressesEmplacement() {
        this.chargementAdresses = true;
        this.emplacementService.ObtenirAdressesEmplacement(this.emplacementId).subscribe({
            next: (adresses) => {
                this.adressesEmplacement = adresses;
                this.chargementAdresses = false;
            },
            error: (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: `Une erreur est survenue lors de la récupération des adresses: ${error.message}`
                });
                this.chargementAdresses = false;
            }
        });
    }

    /// <summary>
    /// Opens dialog to add a new address to the emplacement
    /// </summary>
    ouvrirDialogueAjouterAdresse() {
        this.dialogService.open(AjouterAdresseEmplacementComponent, {
            header: 'Ajouter une nouvelle adresse',
            width: '600px',
            contentStyle: { 'overflow': 'visible' },
            data: { emplacementId: this.emplacementId }
        }).onClose.subscribe((nouvelleAdresse: EmplacementAdresseEntite) => {
            if (nouvelleAdresse) {
                this.adressesEmplacement.push(nouvelleAdresse);
                this.messageService.add({
                    severity: 'success',
                    summary: 'Succès',
                    detail: 'Adresse ajoutée avec succès'
                });
            }
        });
    }

    /// <summary>
    /// Confirms and removes an address from the emplacement
    /// </summary>
    /// <param name="adresse">The address to remove</param>
    confirmerSupprimerAdresse(adresse: EmplacementAdresseEntite) {
        this.confirmationService.confirm({
            message: 'Voulez-vous vraiment supprimer cette adresse ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.emplacementService.SupprimerAdresseEmplacement(this.emplacementId, adresse.emplacementAdresseId).subscribe({
                    next: () => {
                        this.adressesEmplacement = this.adressesEmplacement.filter(a => a.emplacementAdresseId !== adresse.emplacementAdresseId);
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Succès',
                            detail: 'Adresse supprimée avec succès'
                        });
                    },
                    error: (error) => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Erreur',
                            detail: `Une erreur est survenue lors de la suppression de l'adresse: ${error.message}`
                        });
                    }
                });
            }
        });
    }

}
